import React from "react";
import HRLayout from "../layout/HRLayout";

const JobPostings = () => {
  const data = [
    {
      title: "Senior Developer",
      dept: "Engineering",
      location: "Mumbai",
      salary: "₹60000-80000",
      apps: 12,
      status: "Open",
      date: "2026-03-15",
    },
    {
      title: "UI/UX Designer",
      dept: "Design",
      location: "Remote",
      salary: "₹40000-60000",
      apps: 8,
      status: "Open",
      date: "2026-03-18",
    },
    {
      title: "Marketing Manager",
      dept: "Marketing",
      location: "Delhi",
      salary: "₹50000-70000",
      apps: 5,
      status: "Closed",
      date: "2026-02-28",
    },
    {
      title: "DevOps Engineer",
      dept: "Engineering",
      location: "Bangalore",
      salary: "₹70000-90000",
      apps: 3,
      status: "Open",
      date: "2026-03-20",
    },
    {
      title: "Data Analyst",
      dept: "Analytics",
      location: "Hyderabad",
      salary: "₹45000-65000",
      apps: 15,
      status: "On Hold",
      date: "2026-03-10",
    },
  ];

  const statusColor = (status: string) => {
    if (status === "Open") return "bg-green-100 text-green-600";
    if (status === "Closed") return "bg-gray-200 text-gray-600";
    return "bg-yellow-100 text-yellow-600";
  };

  return (
    <HRLayout>
      <h2 className="text-2xl font-bold mb-1">Job Postings</h2>
      <p className="text-gray-500 mb-6">
        Create and manage job openings
      </p>

      {/* SEARCH + BUTTON */}
      <div className="flex justify-between mb-4">
        <input
          placeholder="Search jobs..."
          className="border p-2 rounded w-1/3"
        />
        <button className="bg-green-600 text-white px-4 py-2 rounded">
          + Post Job
        </button>
      </div>

      {/* TABLE */}
      <div className="bg-white rounded-xl shadow">
        <table className="w-full">
          <thead className="border-b text-gray-600">
            <tr>
              <th className="p-3 text-left">Job Title</th>
              <th>Department</th>
              <th>Location</th>
              <th>Salary Range</th>
              <th>Applications</th>
              <th>Status</th>
              <th>Posted Date</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {data.map((item, i) => (
              <tr key={i} className="border-b hover:bg-gray-50">
                <td className="p-3 font-medium">{item.title}</td>
                <td>{item.dept}</td>
                <td>{item.location}</td>
                <td>{item.salary}</td>
                <td>{item.apps}</td>
                <td>
                  <span
                    className={`px-2 py-1 rounded text-sm ${statusColor(
                      item.status
                    )}`}
                  >
                    {item.status}
                  </span>
                </td>
                <td>{item.date}</td>

                {/* ACTIONS */}
                <td className="space-x-2">
                  <button className="text-gray-500 hover:text-black">👁️</button>
                  <button className="text-blue-500 hover:text-blue-700">✏️</button>
                  <button className="text-red-500 hover:text-red-700">🗑️</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </HRLayout>
  );
};

export default JobPostings;